<template>
  <div class="page-header-small">
    <div class="header-content">
      <div class="header-text">
        <h3 class="card-title">{{ title }}</h3>
        <p class="card-description">{{ description }}</p>
      </div>

      <div class="header-actions">
        <div class="action-buttons-top">
          <BButton
            variant="outline-secondary"
            size="sm"
            :disabled="true"
            @click="handle($event, 'info')">
            <Info :size="16" />
          </BButton>

          <BButton  variant="outline-secondary"
                    size="sm"
                    :disabled="true"
                    @click="handle($event, 'export')">
            <Download :size="16" class="me-2" />
            {{ $t('Webportal.Export') }}
          </BButton>

          <BButton  variant="outline-secondary"
                    size="sm"
                    :disabled="true"
                    @click="handle($event, 'share')">
            <Share2 :size="16" class="me-2" />
            {{ $t('Webportal.Share') }}
          </BButton>
        </div>

        <div class="action-buttons-bottom">
          <!-- <BButton
            variant="outline-secondary"
            size="sm"
            @click="handle($event, 'refresh')">
            <RefreshCw :size="16" class="me-2" />
            {{ $t('Webportal.Refresh') }}
          </BButton> -->

          <BButton
            variant="outline-secondary"
            size="sm"
            :disabled="true"
            @click="handle($event, 'save')">
            <Save :size="16" class="me-2" />
            {{ $t('Webportal.SaveView') }}
          </BButton>

          <!-- Neue Komponente statt BFormSelect -->
          <SavedViewSelection v-model="selectedView"
                              style="width: 300px;"
                              :disabled="true"
                              :placeholder="$t('Webportal.ChangeView')"
                              @create="handleCreateView" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Info, Download, Share2, Save, RefreshCw } from 'lucide-vue-next';
import { BButton, BFormSelect } from 'bootstrap-vue-next';
import SavedViewSelection from './SavedViewSelection.vue';

export default {
  name: 'PageHeaderSmall',

  components: {
    Info,
    Download,
    Share2,
    Save,
    RefreshCw,
    BButton,
    SavedViewSelection
  },

  props: {
    title: {
      type: String,
      default: 'Title goes here.'
    },
    description: {
      type: String,
      default: 'Description goes here.'
    },
    viewOptions: {
      type: Array,
      default: () => [{ id: 1, text: 'Default View' }, { id: 2, text: 'Custom View' }]
    }
  },

  emits: ['info',  'export', 'share', 'save', 'refresh', 'view-changed', 'create-view'],

  data() {
    return {
      selectedView: null
    };
  },

  methods: {
    handle(ev, action) {
      console.warn(action, ev);
      this.$emit(action);
    },
    handleCreateView() {
      this.$emit('create-view');
    }
  }
};
</script>

<style lang="scss" scoped>
.page-header-small {
  background: var(--bs-card-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: var(--radius-md);
  padding: 1.5rem;
  transition: all 150ms;

  // &:hover {
  //   border-color: rgba(var(--bs-border-color-rgb), 0.8);
  // }
}

.header-content {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  gap: 1.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.header-text {
  flex: 1;
}

.card-title {
  font-weight: 600;
  line-height: 1.25;
  margin-bottom: 0.375rem;
}

.card-description {
  font-size: 0.875rem;
  line-height: 1.6;
  margin-bottom: 0;
}

.header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}

.action-buttons-top,
.action-buttons-bottom {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.view-select {
  width: 350px;
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>
